import Vue from 'vue'
import VueTimeago from 'vue-timeago'
import intervalToDuration from 'date-fns/intervalToDuration'

Vue.use(VueTimeago, {
  name: 'Timeago', // Component name, `Timeago` by default
  locale: 'en', // Default locale
  locales: {
    es: require('date-fns/locale/es'),
  },
  converter: (date, locale) => {
    const duration = intervalToDuration({
      start: date,
      end: new Date(),
    })
    if (locale?.default.code === 'es') {
      if (duration.years) return `${duration.years} a`
      if (duration.months) return `${duration.months} M`
      if (duration.days) return `${duration.days} d`
      if (duration.hours) return `${duration.hours} h`
      if (duration.minutes) return `${duration.minutes} m`
      return 'justo ahora'
    } else {
      if (duration.years) return `${duration.years} y`
      if (duration.months) return `${duration.months} mo`
      if (duration.days) return `${duration.days} d`
      if (duration.hours) return `${duration.hours} h`
      if (duration.minutes) return `${duration.minutes} m`
      return 'just now'
    }
  },
})
